import React from 'react';
import DetallePedido from '../Global/DetallePedido';
import firebase from '../Firestore'

import VerificarCliente from './VerificarCliente';
//import config from 'react-global-configuration';
//import store from '../../store';

import TimeAgo from 'react-timeago'
import espanolStrings from 'react-timeago/lib/language-strings/es'
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter'


const formatter = buildFormatter(espanolStrings)

class AdminEstadoPedido extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      pedido: [],
      minEspera: undefined,
     };
  }

  levantarDatos(pedidoId){

      let currentComponent = this;
      let db = firebase.firestore()

      var docRef = db.collection("pedido").doc(pedidoId);

      docRef.onSnapshot(function(doc) {
          if (doc.exists) {
              //console.log("Document data:", doc.data());
              let pedido = [];
              pedido[0] = {
                pedidoId: doc.id,
                estado: doc.data().estado,
                fecha: doc.data().fecha,
                total: doc.data().total,
                clienteDireccion: doc.data().clienteDireccion,
                clienteNombre: doc.data().clienteNombre,
                clienteTelefono: doc.data().clienteTelefono,
                formaEntrega: doc.data().formaEntrega,
                momentoEntrega: doc.data().momentoEntrega,
                usuarioProgramarEntrega: doc.data().usuarioProgramarEntrega,
                usuarioAclaraciones: doc.data().usuarioAclaraciones,
                horaEntrega: doc.data().horaEntrega
              }
              let seImprime = doc.data().estado === "ingresado" ? true : false

              currentComponent.setState(
                {
                   pedido: pedido,
                   seImprime: seImprime,
                   estado: doc.data().estado
                 }
              )

          } else {
              // doc.data() will be undefined in this case
              console.log("No such document!");
          }
      });
  }


componentWillMount(){
    //console.log("willMount nro pedido", this.state.nroPedidoMasReciente)
    this.levantarDatos(this.props.pedidoId)
  }

  onClick(e){

    //console.log("ON CLICK", e.target)\
    this.setState(state => ({
      seImprime: !state.seImprime
    }));

    //this.props.onTemperatureChange(e.target.value);

  }

  onChange(e){
    //let currentComponent = this;
    if(e.target.name === "cambiarEstado"){

      if(e.target.value === "cancelado"){
        var r = window.confirm("Va a cancelar el pedido. Esta seguro?");
        if (r == false) {
          return;
        }
      }

      this.setState({estado: e.target.value})
      this.actualizarEstadoBD(e.target.value)
    }

    if(e.target.name === "horaEntrega"){
      this.setState({minEspera: e.target.value})
      this.actualizarHoraEntregaBD(e.target.value)
    }

  }

  actualizarHoraEntregaBD(min){
    var currentComponent = this;

    let dt = new Date();
    dt.setMinutes( dt.getMinutes() + Number(min) );
    let horaEntrega = dt.toLocaleString('es-AR', { timeZone: 'America/Buenos_Aires' });

    let db = firebase.firestore()
    var pedidoRef = db.collection("pedido").doc(this.state.pedido[0].pedidoId);

    return pedidoRef.update({
        horaEntrega: horaEntrega
    })
    .then(function() {
        console.log("Document successfully updated!");
        if(currentComponent.state.estado === "ingresado") currentComponent.actualizarEstadoBD("elaboracion")
    })
    .catch(function(error) {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });


  }



actualizarEstadoBD(estado){
  //console.log("actualizar estado", estado)
  let sigueEnProceso;
  switch (estado) {
    case "entregado":
    case "cancelado":
      sigueEnProceso = false;
      break;
    default:
      sigueEnProceso = true;

  }

  let db = firebase.firestore()
  var pedidoRef = db.collection("pedido").doc(this.state.pedido[0].pedidoId);

  return pedidoRef.update({
      estado: estado,
      enProceso: sigueEnProceso
  })
  .then(function() {
      console.log("Document successfully updated!");
  })
  .catch(function(error) {
      // The document probably doesn't exist.
      console.error("Error updating document: ", error);
  });
}



render() {


      if(this.state.pedido.length === 0) return ""

      let celu = this.state.pedido[0].clienteTelefono.slice(-15, -8).length > 0 ? this.state.pedido[0].clienteTelefono.slice(-15, -8) +'-' : '';
      celu = celu + this.state.pedido[0].clienteTelefono.slice(-8, -4) +"-"+ this.state.pedido[0].clienteTelefono.slice(-4);

      let bg = this.state.estado === "ingresado" ? "bg-warning" : "bg-light";

      let claseNoImprime = "m-2 p-2 border rounded d-print-none " + bg;
      let claseImprime = "m-2 p-2 border rounded " + bg

    return (
      <div className={this.state.seImprime ? claseImprime : claseNoImprime}>
        <div className="custom-control custom-checkbox float-right px-1 d-print-none">
          <input type="checkbox" onChange={event => this.onClick(event)} className="custom-control-input" name="seImprime" id={'seImprime'+this.state.pedido[0].pedidoId} checked={this.state.seImprime}/>
          <label className="custom-control-label" htmlFor={'seImprime'+this.state.pedido[0].pedidoId}><i className="fas fa-print"></i></label>
        </div>


        <div># Pedido <strong>{this.state.pedido[0].pedidoId}</strong>
          | <span className="d-print-none"><TimeAgo date={this.state.pedido[0].fecha.toDate()} formatter={formatter} /> </span>
        <span className="d-none d-print-inline">Ingresado el {this.state.pedido[0].fecha.toDate().toLocaleString()} </span>
          |

          {this.state.pedido[0].momentoEntrega !== "Inmediata" &&
            <span> <span className="badge badge-danger">ENTREGA PROGRAMADA</span> El cliente solicitó la entrega para este día y hora: {this.state.pedido[0].usuarioProgramarEntrega}</span>
          }

          {this.state.pedido[0].horaEntrega && this.state.pedido[0].momentoEntrega === "Inmediata" && this.state.pedido[0].formaEntrega === "Delivery"  &&
            <span> Delivery prometido para <strong>{this.state.pedido[0].horaEntrega.substr(-8, 5)} hs.</strong></span>
          }

          {this.state.pedido[0].horaEntrega && this.state.pedido[0].momentoEntrega === "Inmediata" && this.state.pedido[0].formaEntrega === "Retira"  &&
            <span> Prometido para retirar: {this.state.pedido[0].horaEntrega.substr(-8, 5)} hs.</span>
          }


          <span className="d-print-none"> | Estado: <span className="d-print-none badge badge-primary">{this.state.estado}</span></span>

          <div className="d-print-none d-inline-block m-2 p-2 bg-light text-dark border border-danger rounded">

            <label className="mr-3">
              <div className="mb-0"><strong>Cambiar el Estado</strong> de este pedido
              <small className="d-block mt-0">(el cliente verá la actualización en tiempo real)</small></div>
              <select value={this.state.estado} name="cambiarEstado" onChange={event => this.onChange(event)}>
                <option value="ingresado">Ingresado</option>
                <option value="elaboracion">En elaboración</option>
                <option value="terminado">{this.state.pedido[0].formaEntrega === "Delivery" ? "En camino" : "Listo para retirar"}</option>
                <option value="entregado">Entregado</option>
                <option value="cancelado">Cancelado</option>
              </select>
            </label>

            {this.state.pedido[0].horaEntrega === undefined &&
              <label>
                <div className="mb-0"><strong>{this.state.pedido[0].formaEntrega === "Delivery" ? "Entrega estimada del delivery en:" : "Estará listo para retirar por el local en:"}</strong>
                <small className="d-block mt-0">(info. para el cliente)</small></div>
                <select value={this.state.minEspera} name="horaEntrega" onChange={event => this.onChange(event)}>
                  <option value="0">Tiempo a partir de ahora</option>
                  <option value="15">15 min</option>
                  <option value="30">30 min</option>
                  <option value="45">45 min</option>
                  <option value="60">1 hora</option>
                  <option value="75">1:15 hora</option>
                  <option value="90">1:30 hora</option>
                  <option value="105">1:45 hora</option>
                  <option value="120">2 horas</option>
                </select>
              </label>
            }

          </div>

        </div>


        <div><VerificarCliente telefono={this.state.pedido[0].clienteTelefono} />
        Cliente: <strong>{this.state.pedido[0].clienteNombre}</strong> | Tel. {celu}</div>

          {this.state.pedido[0].formaEntrega === "Delivery" ? (
            <p>Delivery a <strong>{this.state.pedido[0].clienteDireccion}</strong></p>
          ) : (
            <p>Retira por el local</p>
          )}




          {this.state.pedido[0].usuarioAclaraciones.length > 0 &&
            <p>
              <strong>Aclaraciones</strong>: {this.state.pedido[0].usuarioAclaraciones}.
            </p>
          }


          <div className="mx-0">
            <DetallePedido pedidoId={this.state.pedido[0].pedidoId} productoDetalle={this.props.productoDetalle} cat={this.props.cat} adicionalDetalle={this.props.adicionalDetalle} />
          </div>
    </div>
    )
  }

}
export default AdminEstadoPedido
